<template>
  <div class="home homeTm">
    <!-- banner -->
    <home-banner ref="homeBanner" :height="648"></home-banner>

    <div class="mian mainHome">
      <div class="wrap">
        <!-- 热点新闻 -->
        <div class="home_pre clearfloat">
          <div class="home_pre_l fl">
            <div class="homeTopNewTitle">热点新闻</div>
            <!-- <img src="../assets/img/new_top.gif" alt=""> -->
          </div>
          <div class="inner">
            <el-carousel height="94px" direction="vertical" :interval="2500" indicator-position="none">
              <el-carousel-item v-for="item in newsTop" :key="item.entTArticleUuid">
                <div class="homeTopInner">
                  <h3 class="single-line">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{ item.title }}</a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{
                      item.title
                    }}</a>
                  </h3>
                  <p>
                    {{ item.artDesc | ellipsis }}
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">查看详情</a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >查看详情</a
                    >
                  </p>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="wrap">
        <!-- 新闻中心 -->
        <div class="homeTmHd">
          <div class="homeTmHdTitle">
            <h3>新闻动态</h3>
            <p>NEWS CENTER</p>
          </div>
          <div class="homeTmHdLine"></div>
        </div>
        <div class="homeNewsHd homeNewsHdCenter">
          <span
            class="homeNewsHdInner"
            :class="{ active: activeNewsHd == index }"
            v-for="(item, index) in newsHdList"
            :key="index + 'dec01'"
            @mouseenter="mouseenterNewsHd(index)"
          >
            <a :href="item.url" target="_balnk">{{ item.title }}</a>
          </span>
        </div>
        <div class="homeNews">
          <el-row :gutter="40">
            <el-col :span="12">
              <div class="homeNannerBox" v-show="activeNewsHd == 0">
                <div class="swiper-container bannerHomeSec01" id="bannerHomeSec01">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in newsLeft01" :key="index">
                      <a
                        target="_blank"
                        :href="
                          item.url && item.url !== ''
                            ? item.url
                            : `/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`
                        "
                      >
                        <div class="pic">
                          <img :src="item.thumb1" alt="" />
                        </div>
                        <div class="homeTmBannerB">
                          <div class="homeTmBannerBTit">{{ item.title }}</div>
                          <div class="homeTmBannerBTxt">{{ item.artDesc | ellipsis32 }} <span>【查看详情】</span></div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <!-- <div class="swiper-pagination swiper-pagination-sec01"></div> -->
                  <div class="swiper-button-prev swiper-button-prev-sec01"></div>
                  <div class="swiper-button-next swiper-button-next-sec01"></div>
                </div>
              </div>
              <div class="homeNannerBox" v-show="activeNewsHd == 1">
                <div class="swiper-container bannerHomeSec01" id="bannerHomeSec02">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in newsLeft02" :key="index">
                      <a
                        target="_blank"
                        :href="
                          item.url && item.url !== ''
                            ? item.url
                            : `/detail/00440002/${item.entTArticleUuid}`
                        "
                      >
                        <div class="pic">
                          <img :src="item.thumb1" alt="" />
                        </div>
                        <div class="homeTmBannerB">
                          <div class="homeTmBannerBTit">{{ item.title }}</div>
                          <div class="homeTmBannerBTxt">{{ item.artDesc | ellipsis32 }} <span>【查看详情】</span></div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <!-- <div class="swiper-pagination swiper-pagination-sec01"></div> -->
                  <div class="swiper-button-prev swiper-button-prev-sec02"></div>
                  <div class="swiper-button-next swiper-button-next-sec02"></div>
                </div>
              </div>
              <div class="homeNannerBox" v-show="activeNewsHd == 2">
                <div class="swiper-container bannerHomeSec01" id="bannerHomeSec03">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in newsLeft03" :key="index">
                      <a
                        target="_blank"
                        :href="
                          item.url && item.url !== ''
                            ? item.url
                            : `/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`
                        "
                      >
                        <div class="pic">
                          <img :src="item.thumb1" alt="" />
                        </div>
                        <div class="homeTmBannerB">
                          <div class="homeTmBannerBTit">{{ item.title }}</div>
                          <div class="homeTmBannerBTxt">{{ item.artDesc | ellipsis32 }} <span>【查看详情】</span></div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <!-- <div class="swiper-pagination swiper-pagination-sec01"></div> -->
                  <div class="swiper-button-prev swiper-button-prev-sec03"></div>
                  <div class="swiper-button-next swiper-button-next-sec03"></div>
                </div>
              </div>
              <div class="homeNannerBox" v-show="activeNewsHd == 3">
                <div class="swiper-container bannerHomeSec01" id="bannerHomeSec04">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in newsLeft04" :key="index">
                      <a
                        target="_blank"
                        :href="
                          item.url && item.url !== ''
                            ? item.url
                            : `/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`
                        "
                      >
                        <div class="pic">
                          <img :src="item.thumb1" alt="" />
                        </div>
                        <div class="homeTmBannerB">
                          <div class="homeTmBannerBTit">{{ item.title }}</div>
                          <div class="homeTmBannerBTxt">{{ item.artDesc | ellipsis32 }} <span>【查看详情】</span></div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <!-- <div class="swiper-pagination swiper-pagination-sec01"></div> -->
                  <div class="swiper-button-prev swiper-button-prev-sec04"></div>
                  <div class="swiper-button-next swiper-button-next-sec04"></div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="homeNewsBox">
                <ul class="homeTmList" v-if="activeNewsHd == 0">
                  <li v-for="(item, index) in newsRight01" :key="index">
                    <a
                      class="clearfloat"
                      :href="
                        item.url && item.url !== ''
                          ? item.url
                          : `/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`
                      "
                      target="_blank"
                    >
                      <div class="homeTmListTime fl">
                        <h3>{{ dayjs(item.publishDate).format('DD') }}</h3>
                        <p>{{ dayjs(item.publishDate).format('YYYY-MM') }}</p>
                      </div>
                      <div class="homeTmListInner">
                        <h3 class="single-line">{{ item.title }}</h3>
                        <p class="multi-line1">{{ item.artDesc | ellipsisDesc }}</p>
                      </div>
                    </a>
                  </li>
                </ul>
                <ul class="homeTmList" v-if="activeNewsHd == 1">
                  <li v-for="(item, index) in newsRight02" :key="index">
                    <a
                      class="clearfloat"
                      :href="
                        item.url && item.url !== ''
                          ? item.url
                          : `/detail/00440002/${item.entTArticleUuid}`
                      "
                      target="_blank"
                    >
                      <div class="homeTmListTime fl">
                        <h3>{{ dayjs(item.publishDate).format('DD') }}</h3>
                        <p>{{ dayjs(item.publishDate).format('YYYY-MM') }}</p>
                      </div>
                      <div class="homeTmListInner">
                        <h3 class="single-line">{{ item.title }}</h3>
                        <p class="multi-line1">{{ item.artDesc | ellipsisDesc}}</p>
                      </div>
                    </a>
                  </li>
                </ul>
                <ul class="homeTmList" v-if="activeNewsHd == 2">
                  <li v-for="(item, index) in newsRight03" :key="index">
                    <a
                      class="clearfloat"
                      :href="
                        item.url && item.url !== ''
                          ? item.url
                          : `/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`
                      "
                      target="_blank"
                    >
                      <div class="homeTmListTime fl">
                        <h3>{{ dayjs(item.publishDate).format('DD') }}</h3>
                        <p>{{ dayjs(item.publishDate).format('YYYY-MM') }}</p>
                      </div>
                      <div class="homeTmListInner">
                        <h3 class="single-line">{{ item.title }}</h3>
                        <p class="multi-line1">{{ item.artDesc | ellipsisDesc}}</p>
                      </div>
                    </a>
                  </li>
                </ul>
                <ul class="homeTmList" v-if="activeNewsHd == 3">
                  <li v-for="(item, index) in newsRight04" :key="index">
                    <a
                      class="clearfloat"
                      :href="
                        item.url && item.url !== ''
                          ? item.url
                          : `/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`
                      "
                      target="_blank"
                    >
                      <div class="homeTmListTime fl">
                        <h3>{{ dayjs(item.publishDate).format('DD') }}</h3>
                        <p>{{ dayjs(item.publishDate).format('YYYY-MM') }}</p>
                      </div>
                      <div class="homeTmListInner">
                        <h3 class="single-line">{{ item.title }}</h3>
                        <p class="multi-line1">{{ item.artDesc | ellipsisDesc}}</p>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 专题专栏 -->
      <div class="specailN" style="margin: 30px 0;">
        <div class="specailNBox">
          <div class="swiper-container bannerSpecailN">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in specailList" :key="index">
                <a
                  v-if="item.urlType == 1 && item.fileName && item.fileName !== ''"
                  :href="item.url"
                  target="_blank"
                  :title="item.title"
                >
                  <img class="swiper_img" :src="item.fileName" style="width: 100% ; height: 100% ;" />
                </a>
                <a
                  v-if="item.urlType == 2 && item.fileName && item.fileName !== ''"
                  :href="`/list/${item.url}`"
                  target="_blank"
                  :title="item.title"
                >
                  <img class="swiper_img" :src="item.fileName" style="width: 100% ; height: 100% ;" />
                </a>
                <a
                  v-if="item.urlType == 3 && item.fileName && item.fileName !== ''"
                  :href="`/detail/${0}/${item.url}`"
                  target="_blank"
                  :title="item.title"
                >
                  <img class="swiper_img" :src="item.fileName" style="width: 100% ; height: 100% ;" />
                </a>
                <a v-if="item.urlType == 4 && item.fileName && item.fileName !== ''" :title="item.title">
                  <img class="swiper_img" :src="item.fileName" style="width: 100% ; height: 100% ;" />
                </a>
              </div>
            </div>
            <div class="swiper-pagination swiper-pagination-SpecailN"></div>
          </div>
          <!-- <div class="swiper-button-prev swiper-button-prev-specail"></div>
          <div class="swiper-button-next swiper-button-next-specail"></div> -->
        </div>
      </div>

      <!-- 党群工作 -->
      <div class="levelDec">
        <div class="wrap">
          <div class="homeTmHd">
            <div class="homeTmHdTitle">
              <h3>党群建设</h3>
              <p>PART CONSRUCYION</p>
            </div>
            <div class="homeTmHdLine"></div>
          </div>
          <div class="levelDecBox">
            <el-row :gutter="90">
              <el-col :span="12">
                <div class="homeNewsPeriodical">
                  <div class="homeNewsHd">
                    <span class="homeNewsHdInner">
                      <a href="/list/00470001" target="_blank">党务状态</a>
                    </span>
                  </div>
                  <div class="homeDec02Bottom">
                    <ul class="news_list" style="margin-top: -10px;">
                      <li
                        v-for="(item, index) in homeNewsBasicList01"
                        :key="index + 'dec02'"
                        @mouseenter="mouseenterPeriodical(item)"
                      >
                        <div class="news_list_time fr">{{ dayjs(item.publishDate).format('MM-DD') }}</div>
                        <p class="news_list_inner single-line">
                          <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{ item.title }}</a>
                          <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{
                            item.title
                          }}</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="homeNewsBasic">
                  <div class="homeNewsHd">
                    <span class="homeNewsHdInner">
                      <a target="_blank" href="/list/00470002">二十大学习</a>
                    </span>
                  </div>
                  <div class="homeDec02Bottom">
                    <ul class="news_list" style="margin-top: -10px;">
                      <li
                        v-for="(item, index) in homeNewsBasicList02"
                        :key="index + 'dec03'"
                        @mouseenter="mouseenterPeriodical(item)"
                      >
                        <div class="news_list_time fr">{{ dayjs(item.publishDate).format('MM-DD') }}</div>
                        <p class="news_list_inner single-line">
                          <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{ item.title }}</a>
                          <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{
                            item.title
                          }}</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 走进三建 -->
      <div class="aboutSjDec">
        <div class="wrap">
          <div class="aboutSjDecBox">
            <el-row :gutter="20">
              <el-col :span="9">
                <a href="/report/0045" target="_blank" class="aboutSjDecInner">
                  <img src="../assets/img/jb.jpg" alt="" />
                </a>
              </el-col>
              <el-col :span="9" :offset="6">
                <a href="/" target="_blank" class="aboutSjDecInner">
                  <img src="../assets/img/oa.jpg" alt="" />
                </a>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 企业简介 -->
      <div class="companyDecTm">
        <div class="wrap">
          <div class="homeTmHd">
            <div class="homeTmHdTitle">
              <h3>集团概况</h3>
              <p>ABOUT US</p>
            </div>
            <div class="homeTmHdLine"></div>
          </div>
          <div class="companyDecBox">
            <el-row :gutter="40">
              <el-col :span="12">
                <div class="companyDecTmLeftHd">
                  <a href="/listPage/00430001" target="_blank"><img src="../assets/img/about_t.jpg" alt=""></a>
                </div>
                <div class="companyDecTmCont">
                  <p>
                    甘肃建投土木工程建设有限公司隶属于甘肃省建设投资（控股）集团总公司（以下简称甘肃建投），前身为甘肃建投舟曲建设公司。2010年8月，无情的泥石流重创了甘肃建投），前身为甘肃建投舟曲建设公司。2010年8月，无情的泥石流重创了甘肃省舟曲县，在这危难的时刻，甘肃建投挺身而出，在国务院及甘肃省委、省政府的领导下，从甘肃建投内部组建了一支临危受命、敢于拼搏的施工管理队伍——甘肃建投舟曲建设公司。度集中管控”的 “舟曲模式”和“知难而进、勇于坚守甘肃省舟曲县，在这危难的时刻，甘肃建投挺身而出，在国务院及甘肃省委、省政府的领导下，从甘肃建投内部组建了一支临危受命、敢于拼搏的施工管理队伍——甘肃建投舟曲建设公司。舟曲公司以“军事化要求、兵团式作战、资源高度集中管控”的 “舟曲模式”和“知难而进、勇于坚守
                  </p>
                  <a class="companyDecTmMore" href="/listPage/00430001" target="_blank">查看详情</a>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="companyDecRight">
                  <img src="../assets/img/about.jpg" alt="" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 企业业绩 -->
      <div class="casesDec">
        <div class="wrap">
          <div class="homeTmHd">
            <div class="homeTmHdTitle">
              <h3>精品工程</h3>
              <p>SUCCESSFULL CASE</p>
            </div>
            <div class="homeTmHdLine"></div>
          </div>
          <div class="casesBox">
            <div class="casesWrap">
              <ul class="caseList clearfloat">
                <li v-for="(item, index) in caseList01" :key="index">
                  <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                    <img :src="item.thumb1" alt="" />
                    <div class="caseLisTitle trans">
                      <span>
                        {{ item.title | ellipsistran}}
                      </span>
                    </div>
                    <div class="caseLisTxt trans single-line">
                      {{ item.title }}
                    </div>
                    <div class="caseLisBg"></div>
                  </a>
                  <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                    <img :src="item.thumb1" alt="" />
                    <div class="caseLisTitle trans">
                      <span>
                        {{ item.title | ellipsistran}}
                      </span>
                    </div>
                    <div class="caseLisTxt trans single-line">
                      {{ item.title }}
                    </div>
                    <div class="caseLisBg"></div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- 友情链接 -->
      <div class="wrap linkBox">
        <el-row :gutter="50">
          <el-col :span="6">
            <el-select
              v-model="linkValue01"
              placeholder="请选择"
              size="small"
              style="width: 100%;"
              @change="changeLink01"
            >
              <el-option v-for="(item, index) in linkList01" :key="index" :label="item.name" :value="item.httpUrl">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="linkValue02"
              placeholder="请选择"
              size="small"
              style="width: 100%;"
              @change="changeLink02"
            >
              <el-option v-for="(item, index) in linkList02" :key="index" :label="item.title" :value="item.url">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="linkValue03"
              placeholder="请选择"
              size="small"
              style="width: 100%;"
              @change="changeLink03"
            >
              <el-option v-for="(item, index) in linkList03" :key="index" :label="item.title" :value="item.url">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="linkValue04"
              placeholder="请选择"
              size="small"
              style="width: 100%;"
              @change="changeLink04"
            >
              <el-option v-for="(item, index) in linkList04" :key="index" :label="item.title" :value="item.url">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import homeBanner from '@/components/banner/bannerFade.vue'
import { getTopArtList, picArticles, articles, getAdvert, getApplicationList } from '@/api/common'
export default {
  components: {
    homeBanner
  },
  name: 'home',
  data() {
    return {
      activeNewsHd: 0,
      activeNewsHdCase: 0,
      activeNewsHdCulture: 0,
      newsHdList: [
        {
          title: '公司要闻',
          url: '/list/00440001'
        },
        {
          title: '建投要闻',
          url: '/list/00440002'
        },
        {
          title: '行业动态',
          url: '/list/00440003'
        },
        {
          title: '基层声音',
          url: '/list/00440006'
        }
      ],
      activeNewsHdDes02: 0,
      newsTop: [],
      newsLeft01: [],
      newsLeft02: [],
      newsLeft03: [],
      newsLeft04: [],
      newsRight01: [],
      newsRight02: [],
      newsRight03: [],
      newsRight04: [],
      homeNoticeList: [],
      homeDec02Url: '',
      homeDec02ImgUrl: '',
      homeNewsPeriodicalList: [],
      newsNotice: [],
      homeNewsBasicList: [],
      pointImgList: [],
      specailList: [],
      newsNotice01: [],
      newsNotice02: [],
      homeNewsBasicList01: [],
      homeNewsBasicList02: [],
      caseList01: [],
      caseList02: [],
      linkValue01: ' ----内部链接---- ',
      linkValue02: ' ----政府链接---- ',
      linkValue03: ' ----行业链接---- ',
      linkValue04: ' ----媒体链接---- ',
      linkList01: [
        {
          title: '施工技术',
          url: 'http://www.shigongjishu.cn/'
        },
        {
          title: '中国建材第一网 ',
          url: 'http://www.jc001.cn/'
        },
        {
          title: '中国建设工程造价信息网 ',
          url: 'http://www.ccost.com/'
        },
        {
          title: '中国工程建设信息网 ',
          url: 'http://www.cacem.com.cn/index.html'
        },
        {
          title: '甘肃第六建设集团股份有限公司 ',
          url: 'http://www.gsljw.com'
        },
        {
          title: '甘肃第九建设集团公司 ',
          url: 'http://www.gs9j.com/'
        },
        {
          title: '中国施工企业管理协会网 ',
          url: 'http://www.cacem.com.cn/index.html'
        },
        {
          title: '甘肃省土木建筑协会 ',
          url: 'http://www.gstmxh.com/'
        },
        {
          title: '甘肃第一安装工程有限公司 ',
          url: 'http://www.gsya.com.cn'
        },
        {
          title: '中华人民共和国住房和城乡建设部 ',
          url: 'http://www.mohurd.gov.cn/'
        },
        {
          title: '甘肃省建筑业联合会 ',
          url: 'http://www.gsjzy.com/'
        },
        {
          title: '甘肃省国土资源厅 ',
          url: 'http://www.gsdlr.gov.cn/'
        },
        {
          title: '甘肃第五建设集团公司 ',
          url: 'http://www.gs5j.com'
        },
        {
          title: '甘肃第七建设集团股份有限公司 ',
          url: 'http://www.gs7j.com.cn'
        },
        {
          title: '甘肃省住房和城乡建设厅 ',
          url: 'http://www.gsjs.gansu.gov.cn/?tabid=1'
        },
        {
          title: '甘肃第一建设集团有限公司 ',
          url: 'http://www.gsyj.com.cn'
        },
        {
          title: '中国政府网 ',
          url: 'http://www.gov.cn/'
        },
        {
          title: '甘肃省国资委 ',
          url: 'http://www.sasacgs.gov.cn/'
        },
        {
          title: '中国建设报 ',
          url: 'http://www.chinajsb.cn/'
        },
        {
          title: '甘肃建投装备制造有限公司 ',
          url: 'http://www.gcigcem.com.cn/'
        },
        {
          title: '甘肃建投隧道工程有限公司 ',
          url: 'http://www.gsjtsd.com/'
        },
        {
          title: '甘肃省建筑科学研究院 ',
          url: 'http://www.gsjky.com.cn/'
        },
        {
          title: '国家建材网 ',
          url: 'http://www.chinabmnet.com'
        },
        {
          title: '中国建筑业协会 ',
          url: 'http://www.zgjzy.org/'
        },
        {
          title: '甘肃第四建设集团有限公司 ',
          url: 'http://www.gssjjt.com'
        },
        {
          title: '甘肃建投建设有限公司 ',
          url: 'http://www.gsjtjs.com/'
        },
        {
          title: '甘肃省第八建设集团有限责任公司 ',
          url: 'http://www.gs8j.com/'
        },
        {
          title: '中国施工企业管理协会网 ',
          url: 'http://www.cacem.com.cn/index.html'
        },
        {
          title: '西部建材网 ',
          url: 'http://www.xnjcw.com/'
        },
        {
          title: '兰州市人民政府办公厅 ',
          url: 'http://www.lz.gansu.gov.cn/'
        },
        {
          title: '甘肃省政府 ',
          url: 'http://www.gansu.gov.cn/'
        },
        {
          title: '中国建筑经济网 ',
          url: 'http://www.coneco.com.cn/'
        },
        {
          title: '甘肃省建设投资（控股）集团总公司 ',
          url: 'http://www.gsjtw.cc'
        }
      ],
      linkList02: [
        {
          title: '甘肃省人民政府',
          url: 'http://www.gansu.gov.cn'
        },
        {
          title: '甘肃省经济信息网 ',
          url: 'http://www.gsei.com.cn/'
        },
        {
          title: '中华人民共和国住房和城乡建设部 ',
          url: 'http://www.mohurd.gov.cn'
        },
        {
          title: '中国建造师网 ',
          url: 'http://www.coc.gov.cn/coc/'
        },
        {
          title: '中国政府网 ',
          url: 'http://www.gov.cn'
        },
        {
          title: '甘肃省住房和城乡建设厅 ',
          url: 'http://zjt.gansu.gov.cn'
        }
      ],
      linkList03: [
        {
          title: '中国建设报 ',
          url: 'http://www.chinajsb.cn'
        },
        {
          title: '中国建筑业协会 ',
          url: 'http://www.zgjzy.org.cn/'
        },
        {
          title: '中国建造师网 ',
          url: 'http://www.coc.gov.cn'
        },
        {
          title: '中国施工企业管理协会 ',
          url: 'http://www.cacem.com.cn'
        }
      ],
      linkList04: [
        {
          title: '中国建筑经济网 ',
          url: 'http://www.coneco.com.cn'
        },
        {
          title: '施工技术 ',
          url: 'http://www.shigongjishu.cn'
        },
        {
          title: '央视网 ',
          url: 'http://www.cctv.com'
        }
      ]
    }
  },
  mounted() {
    this.getTopArtList()
    this.homeNewsCompany()
    this.bannerHomeSec01()
    this.bannerSpecail()
    this.homeNewsPeriodical()
    this.homeNewsBasic()
    this.caseList()
    this.getApplicationList()
  },
  filters: {
    //超过100位显示 ...
    ellipsis: function(value) {
      if (!value) return ''
      if (value.length > 54) {
        return value.slice(0, 54) + '...'
      }
      return value
    },
    ellipsis32: function(value) {
      if (!value) return ''
      if (value.length > 32) {
        return value.slice(0, 32) + '...'
      }
      return value
    },
    ellipsisDesc: function(value) {
      if (!value) return ''
      if (value.length > 66) {
        return value.slice(0, 66) + '...'
      }
      return value
    },
    ellipsistran: function(value) {
      if (!value) return ''
      if (value.length > 13) {
        return value.slice(0, 13) 
      }
      return value
    },
  },
  methods: {
    // 头条
    getTopArtList() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
      }
      getTopArtList(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsTop = data
        }
      })
    },
    // 集团要闻/建投新闻/党的建设
    homeNewsCompany() {
      var _this = this

      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00440001',
        pageNum: 1,
        pageSize: 5
      }
      articles(data01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight01 = data.rows
        }
      })

      let data02 = {
        entTApplicationUuid: _this.webIdGroup,
        channelUuid: '00190001',
        pageNum: 1,
        pageSize: 5
      }
      articles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight02 = data.rows
        }
      })

      let data03 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00440003',
        pageNum: 1,
        pageSize: 5
      }
      articles(data03).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight03 = data.rows
        }
      })

      let data04 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00440006',
        pageNum: 1,
        pageSize: 5
      }
      articles(data04).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight04 = data.rows
        }
      })
    },
    mouseenterPeriodical(val) {
      var _this = this

      _this.homeDec02ImgUrl = val.thumb1
      _this.homeDec02Url = val.url
    },
    mouseenterNewsHd(val) {
      var _this = this

      _this.activeNewsHd = val
    },
    mouseenterNewsHdCase(val) {
      var _this = this

      _this.activeNewsHdCase = val
    },
    mouseenterNewsHdCulture(val) {
      var _this = this
      _this.activeNewsHdCulture = val
    },
    mouseenterNewsHdDes02(val) {
      var _this = this

      _this.activeNewsHdDes02 = val
    },
    // 焦点图
    bannerHomeSec01() {
      var _this = this

      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00440001',
        pageNum: 1,
        pageSize: 6
      }
      picArticles(data01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsLeft01 = data.rows
          this.$nextTick(() => {
            new Swiper('#bannerHomeSec01', {
              prevButton:'.swiper-button-prev-sec01',
              nextButton:'.swiper-button-next-sec01', 
              loop: true,
              speed: 300,
              autoplay: 2000,
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })

      let data02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00190001',
        pageNum: 1,
        pageSize: 6
      }
      picArticles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsLeft02 = data.rows
          this.$nextTick(() => {
            new Swiper('#bannerHomeSec02', {
              prevButton:'.swiper-button-prev-sec02',
              nextButton:'.swiper-button-next-sec02', 
              loop: true,
              speed: 300,
              autoplay: 2000,
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })
      let data03 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00440003',
        pageNum: 1,
        pageSize: 6
      }
      picArticles(data03).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsLeft03 = data.rows
          this.$nextTick(() => {
            new Swiper('#bannerHomeSec03', {
              prevButton:'.swiper-button-prev-sec03',
              nextButton:'.swiper-button-next-sec03', 
              loop: true,
              speed: 300,
              autoplay: 2000,
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })
      let data04 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00440006',
        pageNum: 1,
        pageSize: 6
      }
      picArticles(data04).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsLeft04 = data.rows
          this.$nextTick(() => {
            new Swiper('#bannerHomeSec04', {
              prevButton:'.swiper-button-prev-sec04',
              nextButton:'.swiper-button-next-sec04', 
              loop: true,
              speed: 300,
              autoplay: 2000,
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })
    },
    // 公告
    bannerHomeNotice() {
      var _this = this
      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00330005',
        pageNum: 1,
        pageSize: 3
      }
      articles(data01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsNotice01 = data.rows
        }
      })

      let data02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0034',
        pageNum: 1,
        pageSize: 3
      }
      articles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsNotice02 = data.rows
        }
      })
    },
    // 党务状态
    homeNewsPeriodical() {
      var _this = this

      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00470001',
        pageNum: 1,
        pageSize: 8
      }
      articles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.homeNewsBasicList01 = data.rows
        }
      })
    },
    // 十九大学习
    homeNewsBasic() {
      var _this = this

      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00470002',
        pageNum: 1,
        pageSize: 8
      }
      articles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.homeNewsBasicList02 = data.rows
        }
      })
    },

    // 专题专栏
    bannerSpecail() {
      var _this = this
      let data = {
        applicationUuid: _this.webId,
        advertType: 3
      }
      getAdvert(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          data.length &&
            data.forEach(line => {
              if (line.fileName && line.fileName !== '') {
                _this.specailList.push(line)
              }
            })
          // _this.specailList = data
          this.$nextTick(() => {
            new Swiper('.bannerSpecailN', {
              effect: 'fade',
              speed: 300,
              autoplay: 3000,
              loop: true,
              paginationClickable :true,
              pagination : '.swiper-pagination-SpecailN',
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })
    },
    
    // 企业业绩
    caseList() {
      var _this = this

      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00460001',
        pageNum: 1,
        pageSize: 20
      }
      picArticles(data01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          let list = []
          data.rows.length &&
            data.rows.forEach(line => {
              if (line.thumb1 && line.thumb1 !== '') {
                list.push(line)
              }
            })
          _this.caseList01 = list.slice(0, 7)
        }
      })

      let data02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00350003',
        pageNum: 1,
        pageSize: 20
      }
      picArticles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          let list = []
          data.rows.length &&
            data.rows.forEach(line => {
              if (line.thumb1 && line.thumb1 !== '') {
                list.push(line)
              }
            })
          _this.caseList02 = list.slice(0, 5)
        }
      })
    },
    getApplicationList(){
      var _this = this

      getApplicationList().then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.linkList01 = [
            {
              name: '甘肃省建设投资（控股）集团总公司 ',
              httpUrl: 'http://www.gsjtw.cc'
            },
            ...data
          ]
        }
      })
    },
    // 友情链接
    changeLink01(val) {
      window.open(val)
    },
    changeLink02(val) {
      window.open(val)
    },
    changeLink03(val) {
      window.open(val)
    },
    changeLink04(val) {
      window.open(val)
    }
  }
}
</script>
<style>
/* img{ 
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%); 
  filter: grayscale(100%);
  filter: url(/img/2013people/gray.svg#grayscale);
  filter: gray;-webkit-filter: grayscale(1);
}
html {filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1); filter: gray;-webkit-filter: grayscale(1);}
.header .zt_banner img.xjp,.header .zt_banner img.database,.cpc_tit img{display:none;}
.datalh{display:block;}
.header{background:#666;} */
.bannerHome {
  height: 620px;
  position: relative;
}
.bannerHome .swiper-wrapper,
.bannerHome .swiper-slide,
.bannerHome img {
  height: 100%;
}
.bannerHome img {
  width: 100%;
}
.swiper-pagination-banner {
  color: #fff;
  font-size: 16px;
}
.swiper-pagination-current {
  font-size: 20px;
}
.bannerHomeSec01 .swiper-wrapper,
.bannerHomeSec01 .swiper-slide,
.bannerHomeSec01 img {
  height: 100%;
}
.bannerHomeSec01 img {
  width: 100%;
  height: 100%;
}
.bannerHomeSec01 .swiper-slide {
  position: relative;
}
/* .bannerHomeSec01 p {
  position: absolute;
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 118px 0 12px;
  left: 0;
  bottom: 0;
  color: #fff;
  font-size: 16px;
  background-color: rgba(0,0,0,0.8);
  box-sizing: border-box;
  text-align: left;
} */
.bannerHomeSec01 .swiper-pagination-bullet {
  width: 44px;
  height: 44px;
  text-align: center;
  border-radius: 0;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 1;
}
.bannerHomeSec01 .swiper-pagination-bullet-active {
  background-color: #ce251f;
}
.bannerHomeSec01 .swiper-pagination .swiper-pagination-current {
  font-size: 30px;
}
/* 友情链接 */
.sec_zfgs_list a {
  display: block;
  text-align: center;
  line-height: 34px;
  border: 1px solid #d5d5d5;
  margin-bottom: 6px;
}

.sec_zfgs_list a:hover {
  border-color: #2b78c6;
  color: #fff;
  background-color: #2b78c6;
}
.homeNotice {
  height: 60px;
  line-height: 60px;
  background-color: #f3f3f3;
  margin: 30px 0;
  padding: 0 35px;
  text-align: center;
}
.homeNoticeL {
  width: 57px;
  height: 28px;
  overflow: hidden;
  border: solid 1px #0d65ac;
  line-height: 28px;
  margin: 17px 0px 0px 0;
  box-sizing: border-box;
}
.homeNoticeBox {
  margin-left: 88px;
  height: 100%;
}
.bannerHomeNotice a {
  font-size: 18px;
}
.bannerHomeNotice a:hover {
  color: #0d65ac;
}
.bannerHomeNotice .swiper-slide {
  width: 300px;
  width: auto;
}
#bannerHomeNotice > .swiper-wrapper {
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}
.homeDec02 {
  margin-bottom: 40px;
}
.homeDec02Img {
  height: 310px;
  overflow: hidden;
  margin-bottom: 15px;
  /* padding: 7px 8px; */
  /* border: solid 1px #D9D2C2; */
}
.homeDec02Img img,
.homeDec02BottomImg img {
  width: 100%;
  height: 100%;
  -moz-transition: all 0.3s ease-in;
  -webkit-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}
.homeDec02Img img:hover,
.homeDec02BottomImg img:hover {
  -moz-transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -o-transform: scale(1.1);
  transform: scale(1.1);
}
.homeDec02BottomImg {
  height: 171px;
  overflow: hidden;
}
.homeDec02Bottom {
  margin-top: 30px;
}
.homeNewsBasicTop p a:hover {
  text-decoration: underline;
}
.homeDec03 {
  margin-top: 30px;
}
.homeTopNewTitle {
  width: 62px;
  height: 62px;
  background-color: #017bce;
  padding: 10px;
  color: #ffffff;
  font-size: 18px;
  letter-spacing: 2px;
  line-height: 20px;
  text-align: center;
  font-weight: bold;
  margin-top: 15px;
  float: left;
  box-sizing: border-box;
}

/* ****************土木公司*************** */
.homeTm .homeTopNewTitle {
  width: 82px;
  height: 82px;
  background-color: #017bce;
  padding: 10px;
  color: #ffffff;
  font-size: 24px;
  letter-spacing: 2px;
  line-height: 30px;
  text-align: center;
  margin-top: 8px;
  float: left;
  border-radius: 4px;
}
.homeTm .bannerHomeSec01 img {
  height: 376px;
}
</style>
